<!-- Progress Bar -->
<pax-funnel-header
  [allMilestones]="productSpecificCustomRouteData.funnelHeaderMilestones"
  (back)="tryNavigateBack()"
  enableBackButton="true"
></pax-funnel-header>

<app-checkout-form-wrapper>
  <pax-section
    [sectionTitle]="productSpecificCustomRouteData.pageTitle"
    [sectionSubtitle]="productSpecificCustomRouteData.pageSubtitle"
    [emojis]="[emoji]"
  >
    @if(hasNoUnderwritingQuestions$ | async){
    {{notEnoughInformationToDisplayUnderwritingQuestionsText}} }

    <div class="pt-6">
      <pax-form-factory
        [formConfiguration]="formConfiguration$ | async"
        [data]="underwritingQuestionsData"
        (formSubmit)="processFormSubmit($event)"
        [isDisabled]="(externalSystemCommunicationStateService.hasAnyPendingBackendRequests$ | async) ?? false"
      >
      </pax-form-factory>
    </div>
  </pax-section>

  <!-- Main Navigation Panel -->
  <pax-bottom-navigation-panel
    (continue)="submitForm()"
    [isBusy]="(externalSystemCommunicationStateService.hasAnyPendingBackendRequests$ | async) ?? false"
  />
</app-checkout-form-wrapper>
